import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Popover } from 'antd';

import { getAvatarText } from './ProfileInfo.helper';
import styles from './ProfileInfo.module.sass';

interface ProfileInfoProps {
  name: string;
}

const ProfileInfo: FC<ProfileInfoProps> = ({ name }: ProfileInfoProps) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const clickHandler = () => {
    navigate('/profile');
  };

  return (
    <Popover zIndex={9999} arrow={false} content={t('translation.profile')}>
      <button type="button" className={styles.avatar} onClick={clickHandler}>
        {getAvatarText(name)}
      </button>
    </Popover>
  );
};

export default memo(ProfileInfo);
